/**
 * useAnunciarRota — anuncia a troca de tela e devolve o foco ao topo (A11Y-05).
 *
 * Numa aplicação de página única a navegação não recarrega nada: o endereço
 * muda, o conteúdo troca, e para quem usa leitor de tela **não aconteceu nada**.
 * O foco também fica onde estava — costuma ser o item de menu clicado —, então
 * o próximo Tab continua de dentro da navegação, não do começo do conteúdo.
 *
 * O `<title>` do documento também é atualizado: é o que o leitor de tela lê ao
 * anunciar uma janela, e o `index.html` tinha um título fixo para o app inteiro.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { anunciar } from '../components/shared/Anuncio';

// Os mesmos nomes do menu (components/casca/navegacao.js).
const NOMES = {
  '/dashboard': 'Dashboard',
  '/crm': 'Clientes',
  '/propostas': 'Propostas',
  '/financeiro': 'Financeiro',
  '/juridico': 'Processos',
  '/agenda': 'Agenda',
  '/kanban': 'Kanban',
  '/documentos': 'Documentos',
  '/contratos': 'Assinaturas',
  '/radar': 'Radar legislativo',
  '/jurisprudencia': 'Jurisprudência',
  '/consultas': 'Consultas',
  '/alertas': 'Alertas',
  '/whatsapp': 'WhatsApp',
  '/whatsapp/painel': 'Painel do atendimento',
  '/formularios': 'Formulários',
  '/configuracoes': 'Configurações',
  '/equipe': 'Equipe',
};

function nomeDaTela(caminho) {
  const chave = Object.keys(NOMES).find((k) => caminho.startsWith(k));
  return chave ? NOMES[chave] : 'EGORA';
}

export function useAnunciarRota() {
  const { pathname } = useLocation();

  useEffect(() => {
    const nome = nomeDaTela(pathname);
    document.title = nome === 'EGORA' ? 'EGORA' : `${nome} — EGORA`;
    anunciar(`${nome} carregado.`);

    const conteudo = document.getElementById('conteudo-principal');
    if (conteudo) {
      // tabIndex -1 permite focar por código sem entrar na ordem do Tab.
      conteudo.setAttribute('tabindex', '-1');
      conteudo.focus({ preventScroll: true });
    }
  }, [pathname]);
}

export default useAnunciarRota;
